import { DatePicker, Layout } from 'antd'
import dayjs from 'dayjs'
import _ from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import { get } from '../../Common/api'
import BoxContext from './BoxContext'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Color } from '../../Common/Color'
import consumer from '../../Common/cable'
import LogsPanel from '../AdminAppointment/LogsPanel'

export default function BoxLogsPage () {
  const [logs, setLogs] = useState([])
  const [newLog, setNewLog] = useState()
  const [date, setDate] = useState(dayjs())
  const { box } = useContext(BoxContext)

  useEffect(() => {
    if (box) {
      const subscription = consumer.subscriptions.create({ channel: 'LogsChannel', box_id: box.id }, {
        connected: () => { console.log('connected') },
        disconnected: () => { console.log('disconnected') },
        received: (data) => { setNewLog(data) }
      })
      return () => {
        subscription.unsubscribe()
      }
    }
  }, [consumer, box])

  useEffect(() => {
    if (newLog && box && dayjs(newLog.created_at).isSame(date, 'day')) {
      setLogs([newLog, ...logs])
    }
  }, [newLog])

  useEffect(() => {
    if (box) {
      getLogs(date)
    }
  }, [box, date])

  const getLogs = async (date) => {
    await get({
      url: 'admin/logs/box',
      params: { box_id: box.id, date: date.format('YYYY-MM-DD') },
      onSuccess: (json) => {
        setLogs(json)
      }
    })
  }

  const sortedLogs = _.orderBy(logs, ['created_at'], ['desc'])

  const onChange = (value) => {
    setDate(value)
  }

  return (
    <Layout style={{ padding: '1em', backgroundColor: 'white' }}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <LeftOutlined onClick={() => setDate(date.add(-1, 'day'))} className='hoverable' style={{ cursor: 'pointer', '--hover-color': Color.red }} />
        <DatePicker style={{ margin: '1em 0em', width: '10em' }} value={date} format={'DD/MM/YYYY'} onChange={onChange}/>
        <RightOutlined onClick={() => setDate(date.add(1, 'day'))} className='hoverable' style={{ cursor: 'pointer', '--hover-color': Color.red }} />
      </div>
      <LogsPanel logs={sortedLogs} date={date} />
    </Layout>
  )
}
